import { Socket } from "socket.io-client";
import { config } from "../../config";

/**
 * Emits an event to the socket server
 * @param socket The socket instance
 * @param clientUUID The client UUID
 * @param eventName The name of the event to emit
 * @param data The data to send with the event
 */
export function emitEvent(
  socket: Socket | null,
  clientUUID: string | null,
  eventName: string,
  data: any
): void {
  if (!config.socket.enable_sockets || !socket) {
    // console.debug(
    //   "MonitoringService: Sockets disabled or not initialized, skipping event:",
    //   eventName
    // );
    return;
  }

  try {
    // Add UUID to every event emission
    const eventData = {
      ...data,
      uuid: clientUUID,
      url: window.location.href,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    socket.emit("client_event", {
      type: eventName,
      data: eventData,
    });
    if (config.env === "development") {
      console.debug("MonitoringService: Event emitted successfully");
    }
  } catch (error) {
    if (config.env === "development") {
      console.error("MonitoringService: Failed to emit event:", error);
    }
  }
}
